export default {
  index: [
    {
      path: '/expensereimburse',
      component: resolve => require(['./expensereimburseIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/expensereimburse/_router.js